import { DialogContentText } from "@material-ui/core";

export default DialogContentText;
